export default "__VITE_ASSET__Ce9nUDz4__"